import { Container, Typography } from '@mui/material';
import { Image } from 'src/components/image';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

const paymentMethods = [
  '/assets/images/payments/permata.png',
  '/assets/images/payments/bri.png',
  '/assets/images/payments/bca.png',
  '/assets/images/payments/mandiri.png',
  '/assets/images/payments/bni.png',
  '/assets/images/payments/qris.png',
  '/assets/images/payments/shopee-pay.png',
  '/assets/images/payments/gopay.png',
  //'/assets/images/payments/ovo.png',
  //'/assets/images/payments/alfamart.png',
  //'/assets/images/payments/indomaret.png',
];

export const PaymentMethod = () => (
  <Container
    sx={{
      mt: { xs: '50px', md: '100px' },
      mb: { xs: '75px', md: '105px' },
    }}
  >
    <div className="flex flex-col gap-[38px]">
      <Typography variant="h3" component="h2" textAlign="center">
        Metode Pembayaran
      </Typography>
      <div className="flex flex-wrap justify-center gap-[20px] md:gap-[35px]">
        {paymentMethods.map((src, index) => (
          <div
            key={index}
            className="w-[110px] h-[70px] rounded-xl bg-gradient-to-b from-white to-[#f5f5f5] border border-[#eaeaea] shadow-[0_4px_6px_rgba(0,0,0,0.05)] flex items-center justify-center px-1"
          >
            <Image
              src={src}
              alt={`Partner ${index + 1}`}
              className="w-full max-h-[40px] object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  </Container>
);